// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__3XpbX","footer":"Footer_footer__2vLr_"};